<template>
  <div class="h-full flex flex-col">
    <div class="flex justify-between px-6 pt-6 lg:pt-10 lg:px-12">
      <span></span>
      <button
        @click="cancel()" v-if="inIframe"
        class="w-8 h-8 rounded-full flex justify-center items-center border border-red-500 text-red-500 hover:bg-red-50"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="h-full flex flex-col md:h-auto md:my-auto">
      <Loader
        v-if="loading"
        class="my-auto"
        text="Please wait.."
      />
      <template v-else>
        <Offers
          v-if="view === 'offers'"
          @done="pushView('pending-review')"
          @skip="replaceView('pending-review')"
        />
        <PendingReview
          v-if="view === 'pending-review'"
          @done="pushView('accounts')"
          @skip="replaceView('accounts')"
        />
        <MultipleAccounts
          v-if="view === 'accounts'"
          @done="pushView('signature')"
          @skip="replaceView('signature')"
        />
        <Signature
          v-if="view === 'signature'"
          @done="pushView('card')"
          @skip="replaceView('card')"
        />
        <RepaymentCard
          v-if="view === 'card'"
          @done="pushView('payment')"
          @skip="replaceView('payment')"
        />
        <VirtualAccountPayment
          v-if="view === 'payment'"
          @done="pushView('connect-whatsapp')"
          @skip="replaceView('connect-whatsapp')"
        />
        <ConnectWhatsapp
          v-if="view === 'connect-whatsapp'"
          @done="pushView('basic-details')"
          @skip="replaceView('basic-details')"
        />
        <BasicDetails
          v-if="view === 'basic-details'"
          @done="next()"
          @skip="next()"
        />
        <Modal v-if="modal === 'fcn-confirmation'">
          <ConfirmFrequentlyCalledNumbers @done="pushView('offers')"/>
        </Modal>
      </template>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/global/Modal.vue";
import Offers from "@/components/core/home/sections/Offers.vue";
import Loader from "@/components/global/Loader.vue";
import view from '@/mixins/view.js';
import Signature from "@/components/core/home/sections/Signature.vue";
import RepaymentCard from "@/components/core/home/sections/RepaymentCard.vue";
import ConfirmFrequentlyCalledNumbers from "@/components/core/home/sections/ConfirmFrequentlyCalledNumbers.vue";
import VirtualAccountPayment from "@/components/core/home/sections/VirtualAccountPayment.vue";
import ConnectWhatsapp from "@/components/core/home/sections/ConnectWhatsapp.vue";
import PendingReview from "@/components/core/home/sections/PendingReview.vue";
import MultipleAccounts from "@/components/core/home/sections/MultipleAccounts.vue";
import BasicDetails from "@/components/core/home/sections/BasicDetails.vue";

export default {
  name: "PostAnalysis",
  components: {
    BasicDetails,
    MultipleAccounts,
    PendingReview,
    ConnectWhatsapp,
    VirtualAccountPayment,
    ConfirmFrequentlyCalledNumbers,
    RepaymentCard,
    Signature,
    Loader,
    Offers,
    Modal
  },
  mixins: [view],
  data() {
    return {
      loading: false,
      inIframe: false
    };
  },
  created() {
    this.inIframe = window.self !== window.top;
    const { stage, offer, payment } = this.$store.state.eligibility;
    if (stage === 'offers' && offer) this.pushView('offers');
    else if (stage === 'offer-selected') this.pushView('pending-review');
    else if (stage === 'signature') this.pushView('signature');
    else if (stage === 'accounts') this.pushView('accounts');
    else if (stage === 'card') this.pushView('card');
    else if (stage === 'payment' && payment) this.pushView('payment');
    else if (stage === 'upfront-paid') this.pushView('connect-whatsapp');
    else if (stage === 'completed') this.next();
    else {
      this.pushView('offers');
    }
  },
  methods: {
    async next() {
      this.loading = true;
      await this.$store.dispatch('eligibility/saveUserData');
      this.loading = false;
      this.$emit('done');
    },
    cancel() {
      this.$bus.$emit('cancel');
    },
  }
};
</script>
